import { TimeoutError } from '#common/types';
import { sleep } from './sleep';
export async function waitForCondition(cond, numIterations = 100, sleepTimeMs = 10) {
    for (let i = 0; i < numIterations; ++i) {
        if (await cond()) {
            return;
        }
        await sleep(sleepTimeMs);
    }
    throw new TimeoutError('Timeout during waitForCondition');
}
